export default {"src":"/_next/static/media/magnify.21da539e.svg","height":117,"width":119,"blurWidth":0,"blurHeight":0};